import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Option, Response} from '../../model/GeneralModels';
import {MobileInsuranceService} from '../../services/mobile-insurance.service';

@Component({
  selector: 'app-company-franchise-field',
  template: `
    <div class="form-group">
      <div class="row col-12" style="margin-right: 1px !important;">
        <div class="col-6" style="margin-left: 5px !important;">
          <app-company-field
            [Group]="Group"
            [viewList]="viewList"
            [required]="required"
            [productName]="productName"
            (OnSelectionChange)="getFranchiseList($event)"
          ></app-company-field>
        </div>
        <div class="col-6" style="margin-left: 5px;">
          <app-select-field
            [Group]="Group"
            [fieldLabel]="'فرانشیز'"
            [options]="franchiseList"
            [viewList]="viewList"
            [fieldName]="'franchiseID'"
            [Icon]="true"
          ></app-select-field>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css',
  ],
})
export class CompanyFranchiseFieldComponent implements OnInit, OnChanges {
  @Input() Group: FormGroup;
  @Input() viewList: any = {};
  @Input() required: boolean;
  @Input() productName: string;
  franchiseList: Option[] = [];
  constructor(private services: MobileInsuranceService) { }

  ngOnInit(): void {
  }

  getFranchiseList(selectedOption) {
    this.franchiseList = [];
    this.Group.controls.franchiseID.patchValue('');
    if (this.Group.controls.companyName.value && selectedOption) {
      this.services.getFranchiseList(this.Group.controls.companyName.value).subscribe((response: Response) => {
        if (response.success) {
          response.data.forEach(franchise => {
            this.franchiseList[this.franchiseList.length] = new Option(franchise.label, franchise.id);
          });
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.Group && !this.Group.controls.franchiseID) {
      this.Group.addControl('franchiseID', new FormControl(''));
    }
    if (this.required) {
      this.Group.controls.franchiseID.setValidators([Validators.required]);
    } else {
      this.Group.controls.franchiseID.setValidators([]);
    }
  }
}
